import React from "react";
import CardLists from "../../components/cardList";
import TableCards from "../../components/tableCards";
import { dateTimeWordLanding } from "../../utils/dateFormatDDMMYYYY";
import { useNavigate } from "react-router-dom";
import Main from "../../components/main";

export default function AuctionList({data, resFeature}){

    const navigate = useNavigate();

    const auctionName = (auction_group) => resFeature?.data?.value?.[auction_group];

    const navigateAuctionDataView = (auctionId) => {
        navigate(`/tractorList/${auctionId}`)
    }
    return (
        <Main>
        <CardLists>
            {data?.map((item ,index) =>
               (
               <CardLists.FixWidth key={index}>
                <CardLists.List >
                <div className="auction_name_container">
                <TableCards.IconContainer style={{width: '48px',height: '48px'}}>
                    <TableCards.Icon src="../assets/icons/auction.svg" alt="auction" />
                </TableCards.IconContainer>
                <CardLists.DetailContainer className="auction_name">
                    <CardLists.ListTitle>{auctionName(item?.auction_group)}</CardLists.ListTitle>
                    <div>
                    {<CardLists.SmallText className="auction_label">{item["name"]}</CardLists.SmallText>}
                    {<CardLists.SmallText>{item["auction_product_count"]} Tractors listed</CardLists.SmallText>}
                    </div>
                </CardLists.DetailContainer>
                </div>
                <div className="date_div">
                <CardLists.DetailContainer  alignItems="center">
                    <TableCards.IconContainer>
                        <TableCards.Icon src="../assets/icons/calendar.svg" alt="calender" />
                    </TableCards.IconContainer>
                    <CardLists.TextContainer>
                        <CardLists.Label>Start Date</CardLists.Label>
                        <CardLists.Text>{dateTimeWordLanding(item?.["start_date"]) }</CardLists.Text>
                    </CardLists.TextContainer>
                </CardLists.DetailContainer>
                <CardLists.DetailContainer  alignItems="center">
                    <TableCards.IconContainer>
                    <TableCards.Icon src="../assets/icons/calendar.svg" alt="calender" />
                    </TableCards.IconContainer>
                    <CardLists.TextContainer>
                        <CardLists.Label>End Date</CardLists.Label>
                        <CardLists.Text>{dateTimeWordLanding(item?.["end_date"])}</CardLists.Text>
                    </CardLists.TextContainer>
                </CardLists.DetailContainer>
                </div>
                <CardLists.ButtonContainer onClick={() => navigateAuctionDataView(item?.["id"])}>
                    <CardLists.Button >PARTICIPATE</CardLists.Button>
                    <TableCards.Icon src="../assets/icons/arrowright.svg" alt="arrowright" />
                </CardLists.ButtonContainer>
            </CardLists.List>
            </CardLists.FixWidth>
            ))}
        </CardLists>
        
        </Main>
    )

}